import axios from 'axios';

export function getScormProgress(registrationId, repoId) {
    try {
        return axios.post(
            `${process.env.REACT_APP_SCORM_CLOUD_MANAGER}/progress/${registrationId}?repositorioPartnerId=${repoId}`
        );
    } catch (error) {
        return {
            error,
        };
    }
}
